import { render, staticRenderFns } from "./bindWx.vue?vue&type=template&id=b3eb3db8&scoped=true"
import script from "./bindWx.vue?vue&type=script&lang=js"
export * from "./bindWx.vue?vue&type=script&lang=js"
import style0 from "./bindWx.vue?vue&type=style&index=0&id=b3eb3db8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eb3db8",
  null
  
)

export default component.exports